import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { generateLabel, generatePickup } from "../../../lib/utils/apiCalls";
import { getNextDate, getRandomTime } from "../../../lib/utils/utils";
import { showToast } from "../../../Components/Toaster/Toaster";

function OrderKebabMenu({ order, boxRef }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [visible, setVisible] = useState(false);

  const orderKebabOpen = useSelector(
    (state) => state.orderManagement.orderKebab.kebabOpen
  );

  useEffect(() => {
    if (orderKebabOpen) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [orderKebabOpen]);

  const handleViewOrder = () => {
    const { orderStatus, orderId } = order;
    const basePath = location.pathname;

    const targetPath =
      orderStatus === "RETURN"
        ? `${basePath}/return-order/${orderId}`
        : `${basePath}/${orderId}`;

    navigate(targetPath);
  };

  const generateShippingLabel = async () => {
    try {
      const response = await generateLabel(order.orderId);
      let pdf_download_link = response[0].pdf_download_link;
      window.open(pdf_download_link, "_blank");
    } catch (err) {
      console.log(err);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const handleCallPickup = async () => {
    const currentDate = new Date().toISOString().split("T")[0];
    const nextDate = getNextDate(currentDate);
    const randomTime = getRandomTime();

    try {
      const callData = {
        pickup_location: `${order.storeAddress.storeName}`,
        package_count: `${order.quantity}`,
        pickup_date: nextDate,
        pickup_time: randomTime,
      };
      const response = await generatePickup(callData);
      console.log(response);
      showToast(`Pickup created for ${nextDate} at ${randomTime}!`, "success");
    } catch (err) {
      console.log(err);
    }
  };

  const handleCancelOrder = () => {};

  return (
    <div
      ref={boxRef}
      className={`${
        visible ? "opacity-100 visible" : "opacity-0 invisible"
      } transition-all duration-150 ease-in-out bg-[#FFFFFF] absolute z-10 w-[200px] top-0 right-7 flex flex-col gap-0 shadow-[0px_0px_12px_0px_#0000003D] rounded-[5px] overflow-hidden`}
    >
      <button
        onClick={handleViewOrder}
        className="w-full select-none flex items-center px-2 py-[10px] rounded hover:bg-[#F5F5F5]"
      >
        <p className="font-medium text-[14px] leading-[22px] text-[#121212]">
          View Order
        </p>
      </button>

      {(order.orderStatus === "PENDING" || order.orderStatus === "EXCHANGE") &&
        order.waybill && (
          <button
            onClick={generateShippingLabel}
            className="w-full select-none flex items-center px-2 py-[10px] rounded hover:bg-[#F5F5F5]"
          >
            <p className="font-medium text-[14px] leading-[22px] text-[#121212]">
              Generate Shipping Label
            </p>
          </button>
        )}

      {/* {
                order.orderStatus !== 'CANCELLED' && 
                <button onClick={handleCallPickup} className='w-full select-none flex items-center px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                    <p className='font-medium text-[14px] leading-[22px] text-[#121212]'>Call Pickup</p>
                </button>
            } */}

      {order.orderStatus !== "CANCELLED" &&
        order.orderStatus !== "RETURN" &&
        order.orderStatus !== "DELIVERED" && (
          <button
            onClick={handleCancelOrder}
            className="w-full select-none flex items-center px-2 py-[10px] rounded hover:bg-[#F5F5F5]"
          >
            <p className="font-medium text-[14px] leading-[22px] text-[#121212]">
              Cancel Order
            </p>
          </button>
        )}
    </div>
  );
}

export default OrderKebabMenu;
